<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementEmarsysRecommendations']
}>()

const emarsysModel = computed(() => props.content?.config?.emarsysModel?.value)
const limit = computed(() => props.content?.config?.limit?.value ?? 5)

const containerId = computed(() => {
    const model = emarsysModel.value ?? 'related'
    return `emarsys-recommender-${model}`
})
</script>

<template>
    <EmarsysRecommenderWidget
        v-if="emarsysModel != null"
        :model="emarsysModel"
        :container-id="containerId"
        :limit="limit"
    />
</template>
